export enum BADGES_SHAPE {
  DEFAULT = 'default',
  ROUNDED = 'rounded'
}
